import { useTheme } from '@emotion/react';
import { useMedia } from '@packlink/utils';
import { Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { TrackingCurrentStatus } from './TrackingCurrentStatus/TrackingCurrentStatus.js';
import { TrackingEstimatedTimeOfDelivery } from './TrackingEstimatedTimeOfDelivery/TrackingEstimatedTimeOfDelivery.js';
import { getTrackingSummaryContentStyles, getTrackingSummaryStatusStyles, getTrackingSummaryDeliveryStyles, getContactLinkWrapperStyles } from './TrackingSummaryStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { isIncidentTrackingStatus } from '../../utils/TrackingStatus.js';
import { ContactLink } from './ContactLink/ContactLink.js';

function TrackingSummary(_ref) {
  let {
    tracking,
    shipment,
    ...otherProps
  } = _ref;
  const {
    estimatedTimeOfDelivery: estimatedTimeOfDeliveryFromTracking,
    currentStatus,
    currentStatusInfo
  } = tracking;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const isLargeTablet = useMedia(theme.mediaQuery('tablet'));
  const estimatedTimeOfDelivery = estimatedTimeOfDeliveryFromTracking !== null && estimatedTimeOfDeliveryFromTracking !== void 0 ? estimatedTimeOfDeliveryFromTracking : shipment === null || shipment === void 0 ? void 0 : shipment.estimatedDeliveryDate;
  const hasIncident = isIncidentTrackingStatus(tracking.currentStatus);
  return jsxs("section", {
    ...otherProps,
    children: [jsx(Typography, {
      variant: "subtitle2",
      bold: true,
      component: "div",
      children: t('tracking-details.titles.status')
    }), jsxs("div", {
      css: getTrackingSummaryContentStyles,
      children: [jsx(TrackingCurrentStatus, {
        css: getTrackingSummaryStatusStyles,
        status: currentStatus,
        statusInfo: currentStatusInfo
      }), estimatedTimeOfDelivery && jsx(TrackingEstimatedTimeOfDelivery, {
        css: getTrackingSummaryDeliveryStyles,
        "data-id": "tracking-estimated-time-of-delivery",
        estimatedTimeOfDelivery: estimatedTimeOfDelivery,
        hasIncident: hasIncident
      }), hasIncident && jsx("div", {
        css: getContactLinkWrapperStyles,
        children: jsx(ContactLink, {
          shipmentReference: tracking.shipmentReference,
          isFullWidth: !isLargeTablet
        })
      })]
    })]
  });
}

export { TrackingSummary };
//# sourceMappingURL=TrackingSummary.js.map
